import voltranApiFactory from '../../modules/voltran/voltranApi'

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils'

/* Actions */
import {getFragmentsActionCreators} from '../actions/voltranActions'

function voltranSagasFactory({storefrontApiClient}) {
  const voltranApi = voltranApiFactory(storefrontApiClient);

  const getFragmentsSaga = generateDefaultAsyncSaga(
    voltranApi.getFragments,
    getFragmentsActionCreators,
    payload => [
      payload.type,
      payload.params,
    ],
    {cacheKey: 'fragment'},
  );

  const watchGetFragments = generateDefaultAsyncWatcher(
    'GET_FRAGMENTS',
    getFragmentsSaga
  );

  const voltranSagas = [
    watchGetFragments(),
  ];

  return voltranSagas;
}

export default voltranSagasFactory;
